export const environment = {
	production: false,
	api: 'https://api.marianalino.com.br',
	apiKey: '',
	sentryDsn:
		'https://ffb27513bd19ccfa558b13220b9ebd53@o4511734566879232.ingest.us.sentry.io/4511734608363520',
	sentryEnvironment: 'production' as 'local' | 'production'
};
